import React from 'react';

const MarketPanelSectorwiseSentiments = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Sectorwise Market Sentiments</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="sectorwise-sentiments">
            <thead>
              <tr>
                <th>Sector Name</th>
                <th>Sentiment</th>
                <th>Strength</th>
                <th>Put-Call Ratio</th>
                <th>Volume</th>
                <th>Change</th>
                <th>% Change</th>
                <th>Top Gainer</th>
                <th>Top Loser</th>
                <th>Market Cap (₹ Cr)</th>
                <th>Outlook</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.sector_name || '-'}</td>
                    <td>{item.sentiment || '-'}</td>
                    <td>{item.strength || '-'}</td>
                    <td>{item.put_call_ratio || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.change || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.top_gainer || '-'}</td>
                    <td>{item.top_loser || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                    <td>{item.outlook || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelSectorwiseSentiments; 